import React, { useState } from "react";
import "./CreateUser.scss";
import CustomForm from "../../../components/CustomForm/CustomForm";
import { adminRequest } from "../../../utils/requestMethods";
import { BASE_URL } from "../../../utils/config";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";

const CreateUser = () => {
  const initialFormData = {
    fullName: "",
    email: "",
    address: "",
    mobileNumber: "",
    role: "",
  };

  const [formData, setFormData] = useState(initialFormData);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const response = await toast.promise(
        adminRequest.post(`${BASE_URL}/user/create`, {
          fullName: formData.fullName,
          email: formData.email,
          address: formData.address,
          mobileNumber: formData.mobileNumber,
          role: formData.role,
        }),
        {
          pending: "Processing your request",
        },
      );

      toast.success(response.data.message, {
        autoClose: 500,
        onClose: () => navigate(-1),
      });

      setFormData(initialFormData);
    } catch (error) {
      toast.error(error.response.data.message);
      console.log(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const fields = [
    {
      name: "fullName",
      label: "Full Name",
      type: "text",
      value: formData.fullName,
      onChange: handleChange,
    },
    {
      name: "mobileNumber",
      label: "Mobile Number",
      type: "text",
      value: formData.mobileNumber,
      onChange: handleChange,
    },
    {
      name: "address",
      label: "Address",
      type: "text",
      value: formData.address,
      onChange: handleChange,
    },
    {
      name: "email",
      label: "Email",
      type: "email",
      value: formData.email,
      onChange: handleChange,
      tail: "Activation links will be sent to this email.",
    },
    {
      name: "role",
      label: "Role",
      type: "select",
      value: formData.role,
      onChange: handleChange,
      options: [
        {
          label: "Select Role",
          value: "",
        },
        {
          label: "Admin",
          value: "ADMIN",
        },
        {
          label: "Accountant",
          value: "ACCOUNTANT",
        },
        {
          label: "Exam Officer",
          value: "EXAM_OFFICER",
        },
      ],
    },
  ];

  return (
    <div className="createAdminContainer">
      <CustomForm
        header="Create User"
        fields={fields}
        flexDirection="row"
        createButtonLabel="Create User"
        onSubmit={handleSubmit}
        isSubmitting={isSubmitting}
      />
      <ToastContainer position="top-center" />
    </div>
  );
};

export default CreateUser;
